<header class="navbar navbar-expand-lg" [class.sidebar-collapsed]="isSidebarCollapsed()"
    [class.navbar-scrolled]="isScrolled">
    <div class="container-fluid px-3 px-lg-4">
        <div class="d-flex align-items-center">
            <!-- Mobile/Small Tablet Logo (visible below 768px) -->
            <a class="logo-container d-lg-none me-3 text-decoration-none"
                [routerLink]="['/dashboard']"
                [msTooltip]="'Dashboard'"
                [msTooltipPlacement]="TooltipPlacement.Bottom">
                <img alt="Logo" src="/ms/images/logos/HOAStart-Logo-Small.png" class="sidebar-logo-small" />
            </a>

            <!-- Desktop Sidebar Collapse Button (visible on tablet and desktop) -->
            <button class="btn btn-icon btn-sm sidebar-toggle d-md-flex me-3" type="button" (click)="toggleSidebar()">
                <fa-duotone-icon [icon]="isSidebarCollapsed() ? 'chevron-right' : 'chevron-left'" secondaryOpacity="0.9" size="lg"/>
            </button>
        </div>
            <dev-bootstrap-size />
        <div class="navbar-nav ms-auto d-flex align-items-center">
            <!-- Desktop/Tablet Icons (visible on tablet and larger screens) -->
            <div class="d-none d-md-flex align-items-center">
                <!-- Dark Theme Switcher -->
                <div class="nav-item me-2 me-lg-3">
                    <ms-theme-switcher></ms-theme-switcher>
                </div>
            </div>

            <!-- Mobile More Menu (visible only on mobile screens) -->
            <div class="nav-item dropdown d-md-none me-2">
                <button class="btn btn-icon btn-sm" type="button" title="More" data-bs-toggle="dropdown">
                    <fa-duotone-icon icon="ellipsis-h" secondaryOpacity="0.9"/>
                </button>
                <div class="dropdown-menu dropdown-menu-end mobile-more-dropdown">
                    <div class="dropdown-header">
                        <span class="fw-bold">Theme</span>
                    </div>
                    <a class="dropdown-item theme-option" data-theme="light"
                        (click)="setTheme('light')" [class.active]="(currentTheme$ | async) === 'light'">
                        <fa-duotone-icon icon="sun-bright" class="me-2"/>Light
                    </a>
                    <a class="dropdown-item theme-option" data-theme="dark"
                        (click)="setTheme('dark')" [class.active]="(currentTheme$ | async) === 'dark'">
                        <fa-duotone-icon icon="moon" secondaryOpacity="0.9" class="me-2"/>Dark
                    </a>
                    <a class="dropdown-item theme-option" data-theme="system"
                        (click)="setTheme('system')" [class.active]="(currentTheme$ | async) === 'system'">
                        <fa-duotone-icon icon="desktop" class="me-2"/>System
                    </a>
                </div>
            </div>

            <ms-top-menu-user (logOutRequested)="logOut()"></ms-top-menu-user>
        </div>
    </div>
</header>
